import {InjectableRxStompConfig} from '@stomp/ng2-stompjs';
import {environment} from '../environments/environment.local';

export const myRxStompConfig: InjectableRxStompConfig = {
  brokerURL: environment.webSocketUrl,

  connectHeaders: {
    Authorization: `Bearer ${localStorage.getItem('accessData') ? JSON.parse(localStorage.getItem('accessData')!).jwt : null}`
  },

  heartbeatIncoming: 0,
  heartbeatOutgoing: 20000,

  // Riconnessione automatica ogni 5 secondi se cade la linea
  reconnectDelay: 5000,

  // debug: (msg: string): void => {
  //   console.log(new Date(), msg);
  // },
}
